// src/tokens/fontSize.ts
var fontSize01 = 12;
var fontSize02 = 14;
var fontSize03 = 16;
var fontSize04 = 20;
var fontSize05 = 32;
export { fontSize01, fontSize02, fontSize03, fontSize04, fontSize05 };